import {isObject} from "../utils";

export default (tagName, definition = {}, children = null) => {
  let _definition = definition;
  let _children = children;

  const vNode = {
    tagName,
    attrs: {},
    on: {},
    children: [],
  };

  if(!isObject(definition)) {
    if(typeof definition === 'string') {
      _definition = {
        attrs: {
          class: definition,
        }
      };
      _children = children || [];
    } else {
      _definition = {};
      _children = definition;
    }
  }

  vNode.children = _children || _definition.children || [];

  if(!Array.isArray(vNode.children)) {
    vNode.children = [vNode.children];
  }

  vNode.children = vNode.children.filter(child => child !== null);

  Object.entries(_definition.attrs || {}).forEach(([name, value]) => {
    if(name === 'class') {
      let className = [];

      if(isObject(value)) {
        className = Object.entries(value).map(([cName, bool]) => {
          if(bool) {
            return cName;
          }
        })
      } else {
        className = !Array.isArray(value) ? [value] : value;
      }

      // take unique classes
      className = [...(new Set(className))];

      vNode.attrs[name] = className;
      return;
    }

    vNode.attrs[name] = value;
  });

  vNode.on = definition.on || {};

  return vNode;
};
